import React, { PropsWithChildren } from 'react';
import { appendClassName } from '../../../../lib/bemUtils/classname';
import { SpanProps } from '../../../../types/HtmlProps';

type WidgetTitleProps = PropsWithChildren<SpanProps>;

export function WidgetTitle({ children, className, ...spanProps }: WidgetTitleProps) {
  return (
    <span className={appendClassName(className, 'widget--header__title-text')} {...spanProps}>
      {children}
    </span>
  );
}
